import React, { Component } from 'react'
import axios from '../../../../Axios'
import { Urls } from '../../../../Urls'
import Locked from '../../../Locked/Locked'


// declaring variables
let turnOver = undefined
let netProfit = undefined
let ownedFleet = undefined
let associatedFleet = undefined
let data = undefined
let turnOverDiv, netProfitDiv, ownedFleetDiv, associatedFleetDiv, downloadTurnover = '#', downloadNetProfit = '#', downloadOwnedFleet = '#', turnoverflag = 1, netflag = 1, ownedflag = 1


export class Intelligence extends Component {
    constructor(props) {
        super(props)
        this.state = {
            downloadTurnover: '#'
        }
    }
    downloadTurnoverFile = () => {
        window.open(downloadTurnover, "_blank")
    }
    downloadNetProfitFile = () => {
        window.open(downloadNetProfit, "_blank")
    }
    downloadOwnedFleetFile = () => {
        window.open(downloadOwnedFleet, "_blank")
    }
    componentWillReceiveProps(incomingData) {
        data = incomingData.intelligencedata
        turnOver = data.turnover
        netProfit = data.net_profit
        ownedFleet = data.owned_fleet
        associatedFleet = data.associated_fleet

        netProfitDiv = (!netProfit) ? (<div id="netProfit" className="netProfit">
            <p>
            <b className="financial_year"> </b><br/>
                <span className="financial_tag">Net Profit (in Crore)</span><br></br>
                <b className="amount">  <Locked/></b>
            </p>

        </div>) : (this.createNetProfit(((netProfit.length) - 1)))
        turnOverDiv = (!turnOver) ? (<div id="turnOver" className="turnOver">
            <p>
            <b className="financial_year"> </b><br/>
                <span className="financial_tag">Turnover  (in Crore)</span><br></br>
                <b className="amount"> <Locked/></b>
            </p>

        </div>) : (this.createTurnover(((turnOver.length) - 1)))
        ownedFleetDiv = (!ownedFleet) ? (<div className="ownedFleet">
            <p>
            <b className="financial_year"> </b><br/>

                <span className="financial_tag">Owned Fleet</span><br></br>
                <b className="amount"> <Locked/> </b>
            </p>
        </div>) : this.createOwnedFleet();
        associatedFleetDiv = (!associatedFleet) ? (<div className="ownedFleet">
            <p>
            <b className="financial_year"> </b><br/>

                <span className="financial_tag">Associated Fleet</span><br></br>
                <b className="amount"> <Locked/> </b>
            </p>
        </div>) : this.associatedFleetDiv();
    }
    componentDidUpdate() {
      /*   if (turnoverflag == 0) {
            document.getElementById('turnover-view').style.display = 'none'

        }
        if (netflag == 0) {
            document.getElementById('netprofit-view').style.display = 'none'

        }
        if (ownedflag == 0) {
            document.getElementById('ownedfleet-view').style.display = 'none'

        } */
    }

    createTurnover = (n) => {
        turnoverflag = 1;
        if (n >= 0) {
            if (turnOver[n].balanceSheet) {
                // axios.get(`${Urls.blobUrl}?action=download&filename=${turnOver[n].balanceSheet}&request_timestamp=${(new Date()).toISOString()}`)
                let body = {
                    'action': 'download',
                    'accountName': 'lorrifilesproduction',
                    'containerName': 'private-container',
                    'fileName': `${turnOver[n].balanceSheet}`
                }
                axios.post(Urls.fileService, body)
                    .then(res => {
                        downloadTurnover = res.data.url
                        this.setState({ downloadTurnover: res.data.url })

                    })
                    .catch(err => {
                        console.log(err)
                        turnoverflag = 0
                    })
            }
            if (!turnOver[n].balanceSheet) {
                turnoverflag = 0;
            }
            return <div id="turnOver" className="turnOver">
                <p>
                    <b className="financial_year"> {(!turnOver[n].financial_year) ? ('') : (<>FY: {turnOver[n].financial_year}</>)} </b><br></br>
                    <span className="financial_tag">Turnover  (in Crore)</span><br></br>
                    <b className="amount"><Locked/></b>
                </p>
                <p>
                    <button className="view-button" id="turnover-view"  onClick={e=>document.getElementById('Login_to_view_button').click()}> <span className="view">View Balance Sheet</span> </button>
                </p>
            </div>
        }


    }
    createNetProfit = (n) => {
        netflag = 1;

        if (n >= 0) {
            if (netProfit[n].pnl_statement != null && netProfit[n].pnl_statement != undefined && netProfit[n].pnl_statement != '') {
                // axios.get(`${Urls.blobUrl}?action=download&filename=${netProfit[n].pnl_statement}&request_timestamp=${(new Date()).toISOString()}`)
                let body = {
                    'action': 'download',
                    'accountName': 'lorrifilesproduction',
                    'containerName': 'private-container',
                    'fileName': `${netProfit[n].pnl_statement}`
                }
                axios.post(Urls.fileService, body)
                    .then(res => {
                        downloadNetProfit = res.data.url


                    })
                    .catch(err => {
                        console.log(err)
                        netflag = 0
                    })
            }
            if (!netProfit[n].pnl_statement) {
                netflag = 0;
            }
            return <div id="netProfit" className="netProfit">
                <p>
                    <b className="financial_year"> {(!netProfit[n].financial_year) ? ('') : (<>FY: {netProfit[n].financial_year}</>)}</b><br></br>
                    <span className="financial_tag">Net Profit (in Crore)</span><br></br>
                    <b className="amount"><Locked/></b>
                </p>
                <p class="justify-content-center">

                    <button className="view-button" id="netprofit-view" onClick={e=>document.getElementById('Login_to_view_button').click()}> <span className="view">View PNL Statement</span> </button>  {/* <button className="download-button" id="netprofit-download" onClick={this.downloadNetProfitFile} > <span className="download">Download</span> </button>
         */}</p>
            </div>

        }



    }
    createOwnedFleet = () => {

        if (ownedFleet.fleet_list) {
            // axios.get(`${Urls.blobUrl}?action=download&filename=${ownedFleet.fleet_list}&request_timestamp=${(new Date()).toISOString()}`)
            let body = {
                'action': 'download',
                'accountName': 'lorrifilesproduction',
                'containerName': 'private-container',
                'fileName': `${ownedFleet.fleet_list}`
            }
            axios.post(Urls.fileService, body)
                .then(res => {
                    downloadOwnedFleet = res.data.url


                })
                .catch(err => {
                    console.log(err)
                    ownedflag = 0
                })
        }
        if (!ownedFleet.fleet_list) {
            ownedflag = 0;
        }
        return <div className="ownedFleet">
            <p>
                <b className="financial_year"> </b><br></br>
                <span className="financial_tag">Owned Fleet</span><br></br>
               {/*  <b className="amount"> {(!ownedFleet.amount) ? ('N/A') : (ownedFleet.amount)} </b> */}
               <b className="amount"> <Locked/></b>
            </p>
            <p>
                <button className="view-button" id="ownedfleet-view"  onClick={e=>document.getElementById('Login_to_view_button').click()}> <span className="view">View</span> </button>
 </p>
        </div>


    }
    associatedFleetDiv = () => {

        return <div className="ownedFleet">
            <p>
                <b className="financial_year"> </b><br></br>
                <span className="financial_tag">Associated Fleet</span><br></br>
               {/*  <b className="amount"> {(!ownedFleet.amount) ? ('N/A') : (ownedFleet.amount)} </b> */}
               <b className="amount"> <Locked/></b>
            </p>
            <p>
                <button className="view-button" id="ownedfleet-view"  onClick={e=>document.getElementById('Login_to_view_button').click()}> <span className="view">View</span> </button>
 </p>
        </div>


    }

    render() {
        if (!data) {
            return (
                <div>
                    <p>Details not available</p>

                </div>
            )
        }
        else {
            return (
                <div className="row" style={{ display: 'flex' }}>
                    {turnOverDiv}
                    {netProfitDiv}
                    {ownedFleetDiv}
                    {associatedFleetDiv}
                </div>
            )


        }
    }
}

export default Intelligence
